import '../../assets/css/style.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import React from 'react';

import { ThemeProvider } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import { theme } from '../../components/layout/Style';

import HeaderWebPage from './HeaderWebPage';
import FooterWebPage from './FooterWebPage';
import BackToTop from '../../components/templates/BackToTop';
import { INSTITUTIONAL_HEADER_MENU_ITEMS } from '../shared/headerMenus';

const TermosDeUso = () => (
  <ThemeProvider theme={theme}>
    <CssBaseline />
    <div>

      <HeaderWebPage
        menuItems={INSTITUTIONAL_HEADER_MENU_ITEMS}
      />

      <section id="termos">
        <div className="termos-title-grid">
          <h1>Termos de Uso</h1>
        </div>

        <div className="termos-grid">
          <div className="termo">
            <p>Este documento estabelece os Termos de Uso que regem a utilização do aplicativo <strong>PASSARELA 44</strong>, desenvolvido e mantido por <strong>CREATIVE IT LTDA</strong>, inscrita no CNPJ sob nº 64.436.153/0001-69, com sede em Goiânia, Goiás. Ao acessar ou utilizar o aplicativo, o usuário declara ter lido, compreendido e aceito integralmente os presentes termos.</p>
          </div>
        </div>

        <div className="termos-grid">
          <div className="termo">
            <h2>Objeto</h2>
            <p>O aplicativo PASSARELA 44 tem por finalidade oferecer uma plataforma digital de comércio eletrônico, por meio da qual lojistas podem anunciar produtos e usuários podem consultá-los, realizar cadastro, efetuar compras e acompanhar pedidos, conforme as funcionalidades disponibilizadas.</p>
          </div>
        </div>

        <div className="termos-grid">
          <div className="termo">
            <h2>Cadastro e Conta de Acesso</h2>
            <p>Para utilizar as funcionalidades do aplicativo, o usuário deverá realizar cadastro mediante fornecimento de dados pessoais verídicos e atualizados. O uso de informações falsas ou de terceiros sem autorização poderá ensejar a suspensão ou exclusão da conta, sem prejuízo das medidas legais cabíveis.</p>
            <p>O usuário é responsável por manter a confidencialidade de suas credenciais de acesso, sendo vedado o compartilhamento de login e senha com terceiros. Em caso de suspeita de uso indevido, o usuário deverá comunicar imediatamente a equipe de suporte.</p>
          </div>
        </div>

        <div className="termos-grid">
          <div className="termo">
            <h2>Responsabilidades do Usuário</h2>
            <p>O usuário compromete-se a utilizar o aplicativo de forma ética, lícita e respeitosa, abstendo-se de:</p>
            <ul>
              <li>Praticar atos que violem direitos de terceiros, incluindo propriedade intelectual, privacidade ou honra;</li>
              <li>Inserir conteúdo ofensivo, discriminatório, ilegal ou que contrarie os princípios da boa-fé;</li>
              <li>Utilizar o aplicativo para fins fraudulentos ou contrários à legislação vigente.</li>
            </ul>
            <p>O descumprimento destas obrigações poderá resultar na suspensão ou cancelamento da conta, além de responsabilização civil e penal conforme previsto no Código Civil e no Código Penal.</p>
          </div>
        </div>

        <div className="termos-grid">
          <div className="termo">
            <h2>Responsabilidades do Lojista</h2>
            <p>O lojista é integralmente responsável pela veracidade das informações dos produtos anunciados, incluindo descrição, preço, disponibilidade e condições de entrega. Também é responsável pelo cumprimento das obrigações decorrentes das vendas realizadas, nos termos do Código de Defesa do Consumidor.</p>
            <p>O aplicativo atua como intermediador tecnológico, não sendo parte nas relações contratuais entre lojistas e consumidores, tampouco garante a qualidade, entrega ou conformidade dos produtos anunciados.</p>
          </div>
        </div>

        <div className="termos-grid">
          <div className="termo">
            <h2>Propriedade Intelectual</h2>
            <p>Todos os direitos de propriedade intelectual relacionados ao aplicativo, incluindo marca, logotipo, layout, funcionalidades, textos e códigos-fonte, são de titularidade exclusiva da CREATIVE IT LTDA, sendo vedada sua reprodução, modificação ou distribuição sem autorização expressa.</p>
            <p>O conteúdo inserido pelos usuários e lojistas permanece de propriedade dos respectivos titulares, que concedem ao aplicativo licença não exclusiva para exibição e divulgação conforme as finalidades da plataforma.</p>
          </div>
        </div>

        <div className="termos-grid">
          <div className="termo">
            <h2>Privacidade e Proteção de Dados</h2>
            <p>O tratamento dos dados pessoais coletados pelo aplicativo será realizado conforme a Política de Privacidade vigente e em observância à Lei nº 13.709/2018 – LGPD. O usuário poderá exercer seus direitos como titular, conforme previsto no artigo 18 da referida lei.</p>
          </div>
        </div>

        <div className="termos-grid">
          <div className="termo">
            <h2>Limitação de Responsabilidade</h2>
            <p>O aplicativo não se responsabiliza por:</p>
            <ul>
              <li>Falhas na conexão de internet ou indisponibilidade temporária da plataforma;</li>
              <li>Danos decorrentes de condutas de terceiros, incluindo lojistas e usuários;</li>
              <li>Perdas financeiras ou prejuízos decorrentes de transações comerciais realizadas fora dos parâmetros da plataforma.</li>
            </ul>
          </div>
        </div>

        <div className="termos-grid">
          <div className="termo">
            <h2>Modificações nos Termos</h2>
            <p>Estes Termos de Uso poderão ser alterados a qualquer momento, mediante publicação da versão atualizada no aplicativo. Recomenda-se a leitura periódica. O uso continuado da plataforma após alterações será considerado como aceitação tácita dos novos termos.</p>
          </div>
        </div>

        <div className="termos-grid">
          <div className="termo">
            <h2>Foro e Legislação Aplicável</h2>
            <p>Estes Termos serão regidos pelas leis da República Federativa do Brasil. Fica eleito o foro da comarca de Goiânia, no estado de Goiás, com renúncia a qualquer outro, por mais privilegiado que seja, para dirimir eventuais controvérsias oriundas da utilização do aplicativo.</p>
            <br />
            <br />
            <br />
            <p>Última atualização: 21/01/2026</p>
          </div>
        </div>
      </section>

      <FooterWebPage />

    </div>
    <BackToTop/>
  </ThemeProvider>
)

export default TermosDeUso;